var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMartini(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 109.71 124.68",
    width: "1em",
    height: "1em"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".martini_svg__cls-1{fill:none;stroke:#000;stroke-linecap:round;stroke-miterlimit:10;stroke-width:18px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "martini_svg__Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "martini_svg__Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "martini_svg__cls-1",
    d: "M54.86 54.86L106.71 3M54.86 54.86L3 3M3 3l28.46 28.46a33.09 33.09 0 0046.79 0L106.71 3M54.86 110.57V54.86M31.2 121.68h47.32M54.86 110.57l10.95 10.95M54.86 110.57L44.02 121.4"
  })))));
}

var MemoSvgMartini = /*#__PURE__*/React.memo(SvgMartini);
export default MemoSvgMartini;